import { useEffect, useState } from "react"
import UserService from "services/user.service"
import { tabStyles } from "./GeneralData"
import classNames from "classnames"
import { useRouter } from "hooks/useRouter"
import { DATE } from "./trainings/WeeklyStats"
import { ManagerStats } from "./media-ads/ManagerStats"
import { AdStats } from "./media-ads/AdStats"
import { AdSpending } from "./media-ads/AdSpending"
import DatePicker from "react-datepicker"
import moment from "moment"
import { useDebounce } from "hooks/useDebounce"

const service = new UserService()

export const MediaStats = () => {
  const [showCustom, setShowCustom] = useState(false)
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)
  const [date, setDate] = useState("YEARTODATE")
  const [pagination, setPagination] = useState({
    mgmtLeaderName: '',
    regionalName: '',
  })

  const [data, setData] = useState<any>({
    manager_wise_stats: [],
    social_media_ad_stats: [],
    ad_counts_with_price: [],
  })

  const { query, push } = useRouter()
  const debounced = useDebounce(pagination, 500)

  useEffect(() => {
    setLoading(true)
    service
      .getMediaStats({ ...debounced, date })
      .then((resp) => {
        const root = resp?.data
        const payload =
          root &&
          typeof root === "object" &&
          root.data != null &&
          typeof root.data === "object" &&
          !Array.isArray(root.data)
            ? root.data
            : root
        setData({
          manager_wise_stats: Array.isArray(payload?.manager_wise_stats)
            ? payload.manager_wise_stats
            : [],
          social_media_ad_stats: Array.isArray(payload?.social_media_ad_stats)
            ? payload.social_media_ad_stats
            : [],
          ad_counts_with_price: Array.isArray(payload?.ad_counts_with_price)
            ? payload.ad_counts_with_price
            : [],
        })
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [date, debounced])

  const handleChangeDates = (dates) => {
    const [start, end] = dates

    setStartDate(start)
    setEndDate(end)

    if ((!start && !end) || end) {
      setDate(
        `${moment(start).format("YYYY-MM-DD")},${moment(end).format(
          "YYYY-MM-DD"
        )}`
      )
    }
  }

  return (
    <div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => push("/media-ads")}
          className="rounded-md bg-white border border-gray-200 px-4 py-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
        </button>
        <select
          value={date}
          className="w-60 px-3 py-2 text-sm"
          onChange={(e) => {
            if (e.target.value !== "CUSTOM") {
              setDate(e.target.value)
            } else {
              setShowCustom(true)
            }
          }}
        >
          <option>Select</option>
          {DATE.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
        {showCustom && (
          <DatePicker
            selected={startDate}
            placeholderText="Select range"
            onChange={handleChangeDates}
            startDate={startDate}
            endDate={endDate}
            isClearable
            className="z-100 ml-2 py-2 w-60"
            customInput={
              <input
                placeholder="Select date"
                className="w-60 px-3 py-2 text-sm"
              />
            }
            selectsRange
            selectsDisabledDaysInRange
          />
        )}
        <div className="flex items-center gap-2">
          <input
            type="text"
            placeholder="Management Leader Name"
            value={pagination.mgmtLeaderName}
            onChange={(e) => setPagination({ ...pagination, mgmtLeaderName: e.target.value })}
            className="w-60 px-3 py-2 text-sm"
          />
          <input
            type="text"
            placeholder="Regional Name"
            value={pagination.regionalName}
            onChange={(e) => setPagination({ ...pagination, regionalName: e.target.value })}
            className="w-60 px-3 py-2 text-sm"
          />
          <button
            type="button"
            onClick={() => setPagination({ ...pagination, mgmtLeaderName: '', regionalName: '' })}
            className="rounded-md bg-white border border-gray-200 px-4 py-2 text-sm text-gray-800"
          >
            Clear
          </button>
        </div>
      </div>

      <div className="tabs my-4">
        <div className="flex flex-wrap gap-1">
          <button
            type="button"
            onClick={() => push("/media-stats")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: !query.tab,
            })}
          >
            Manager Stats
          </button>
          <button
            type="button"
            onClick={() => push("/media-stats?tab=ad-stats")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: query.tab === "ad-stats",
            })}
          >
            Ad Stats
          </button>
          <button
            type="button"
            onClick={() => push("/media-stats?tab=spending")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: query.tab === "spending",
            })}
          >
            Ad Sepnding
          </button>
        </div>
      </div>
      {!query.tab ? (
        <ManagerStats loading={loading} data={data?.manager_wise_stats} />
      ) : query.tab === "ad-stats" ? (
        <AdStats data={data.social_media_ad_stats} />
      ) : (
        <AdSpending stats={data.ad_counts_with_price} />
      )}
    </div>
  )
}
